import type { CheckAvailabilityRequestBody } from './types';

import { URL } from 'app/api/constants';
import type { ServiceConfig } from 'app/api/utils/create-http-api-service';
import { defaultRequestService } from 'app/api/utils/default-request-service';
import type { CheckAvailabilitySuccessPayload } from 'app/modules/BetSlip/actions';


export const checkAvailability = (
  config: ServiceConfig,
  requestData: CheckAvailabilityRequestBody,
) => {
  type AdapterProps = { request: typeof requestData; response: CheckAvailabilitySuccessPayload };

  return defaultRequestService<AdapterProps>(URL.CHECK_AVAILABILITY, config.instance.post, {
    requestData,
  });
};
